module.exports = __webpack_public_path__ + "static/media/Sanomat Grab Web-XBold.3301a040.eot";